{
  "shippingServices": {
    "ECONOMY": "Economy",
    "STANDARD": "Standard",
    "PRIORITY": "Priority",
    "GROUND": "Ground",
    "INTL_STANDARD": "International Standard",
    "INTL_EXPRESS": "International Express",
    "NEXT_DAY": "Overnight",
    "INTERNATIONAL": "International"
  },
  "shippingZones": {
    "US_DOMESTIC": "US domestic",
    "US_HAWAII_AK": "Hawaii & Alaska",
    "CANADA": "Canada",
    "EU": "European Union",
    "UK": "United Kingdom",
    "AUSTRALIA": "Australia",
    "REST_OF_WORLD": "Rest of world"
  },
  "initialsAvatar": {
    "noImage": "No image"
  },
  "shippingFees": {
    "title": "Shipping Fees",
    "description": "Shipping fee tables (Shipping Rate Engine v2) — per destination country / US ZIP3 grid + ZIP5 exceptions."
  },
  "blueprintCost": {
    "title": "Blueprint Cost",
    "description": "View-only — vendor production cost per blueprint variant. Cost is managed on the vendor side (capability assignment / product approval); click a name to open the Blueprint Detail page.",
    "search": "Search",
    "searchPlaceholder": "Search by blueprint, SKU or vendor…",
    "error": "Failed to load blueprint costs.",
    "empty": "No blueprint costs match the current filter.",
    "columns": {
      "blueprint": "Blueprint",
      "variantSku": "Variant SKU",
      "vendor": "Vendor",
      "productionCost": "Production cost",
      "seasonalCost": "Seasonal cost",
      "procDays": "Proc. days",
      "quality": "Quality",
      "country": "Country",
      "status": "Status"
    },
    "statusLabels": {
      "approved": "Approved",
      "pending_approval": "Pending approval",
      "rejected": "Rejected"
    },
    "pagination": {
      "prev": "Prev",
      "next": "Next"
    }
  },
  "pricesV2": {
    "title": "Pricing",
    "subtitle": "View products with tier pricing",
    "exportAll": "Export All",
    "networkError": "Failed to load prices.",
    "empty": "No blueprints match",
    "searchPlaceholder": "Search products or SKUs…",
    "allTiers": "All Tiers",
    "selectBlueprint": "Select {{name}}",
    "selectVariant": "Select {{sku}}",
    "variantsBadge_one": "{{count}} variant",
    "variantsBadge_other": "{{count}} variants",
    "stats": {
      "products": "Products",
      "variants": "Variants",
      "skus": "SKUs",
      "avgPrice": "Avg. Price",
      "avgShipping": "Avg. Shipping"
    },
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "shippingDisplay": "Shipping",
    "shippingInMatrix": "In matrix",
    "shippingSidePanel": "Side panel",
    "viewShipping": "Shipping",
    "table": {
      "sku": "SKU",
      "variant": "Variant",
      "pricing": "PRICING",
      "shipping": "Shipping",
      "fee": "Fee",
      "extra": "Extra",
      "base": "Base"
    },
    "panel": {
      "title": "Shipping fees",
      "method": "Method",
      "fee": "Fee",
      "extra": "Extra (2nd+)",
      "close": "Close",
      "empty": "No shipping fees for this variant."
    }
  },
  "configPage": {
    "title": "Pricing configuration",
    "subtitle": "Seasonal surcharges, embroidery rules, tax/tariff and digitizing — applied on the next quote/confirm.",
    "readOnly": "You need the pricing:manage permission to edit these settings.",
    "save": "Save configuration",
    "saving": "Saving…",
    "savedToast": "Configuration saved.",
    "errorToast": "Could not save the configuration.",
    "validationToast": "Please fix the highlighted fields.",
    "tabs": {
      "seasonal": "Seasonal",
      "embroidery": "Embroidery",
      "tax": "Tax & tariff",
      "digitizing": "Digitizing"
    },
    "seasonal": {
      "title": "Seasonal surcharge",
      "variantIdLabel": "Variant ID",
      "variantIdPlaceholder": "Variant _id",
      "feeLabel": "Seasonal fee",
      "windowStartLabel": "Window start",
      "windowEndLabel": "Window end",
      "bulkTitle": "Bulk apply by weight range",
      "weightMinLabel": "Min weight (g)",
      "weightMaxLabel": "Max weight (g)",
      "bulkFeeLabel": "Fee to apply",
      "windowPassedReport": "Warning: seasonal fee greater than 0 but the window has already passed."
    },
    "embroidery": {
      "title": "Embroidery stitch rules",
      "minStitchesLabel": "Min stitches",
      "maxStitchesLabel": "Max stitches",
      "feeLabel": "Fee for range",
      "addRule": "Add rule",
      "removeRule": "Remove"
    },
    "tax": {
      "title": "Reciprocal tariff",
      "vendorIdLabel": "Vendor ID",
      "zoneLabel": "Destination zone",
      "rateLabel": "Tariff per unit (USD)",
      "createTariff": "Create tariff",
      "blueprintIdLabel": "Blueprint ID"
    },
    "digitizing": {
      "title": "Global digitizing fee",
      "feeLabel": "Digitizing fee",
      "helper": "Charged once per new embroidery design."
    }
  },
  "skuPrices": {
    "title": "Prices",
    "description": "Selling price per SKU and location for every active tier, with shipping fees per service.",
    "search": {
      "placeholder": "Search blueprint, SKU or variant",
      "aria": "Search prices"
    },
    "filters": {
      "location": "Location",
      "category": "Category",
      "vendor": "Vendor",
      "locationAria": "Filter by location",
      "categoryAria": "Filter by category",
      "vendorAria": "Filter by vendor",
      "clearHint": "Click again to clear",
      "loadingOptions": "Loading…",
      "loadError": "Could not load options",
      "searchPlaceholder": "Search…",
      "searchAria": "Search options",
      "noResults": "No results",
      "searchError": "Search failed. Edit or clear the search.",
      "selectedFallback": "1 selected"
    },
    "columns": {
      "blueprint": "Blueprint",
      "sku": "SKU",
      "variantName": "Variant Name",
      "location": "Location",
      "tax": "Tax",
      "tiktok": "Tiktok",
      "status": "Blueprint Status",
      "variantStatus": "Variant Status",
      "shipFee": "Shipping ({{service}})",
      "shipSeasonal": "Seasonal ({{service}})",
      "shipExtra": "Additional ({{service}})",
      "shipTariff": "Reciprocal Tariff ({{service}})",
      "shipParts": {
        "fee": "Shipping",
        "seasonal": "Seasonal",
        "extra": "Additional",
        "tariff": "Reciprocal Tariff"
      },
      "toggle": "Columns",
      "reset": "Reset columns",
      "saveError": "Could not save the column view. Changes were reverted."
    },
    "groups": {
      "pricing": "Pricing",
      "shipping": "Shipping: {{service}}"
    },
    "values": {
      "yes": "Yes",
      "no": "No"
    },
    "status": {
      "Draft": "Draft",
      "PendingApproval": "Pending approval",
      "Active": "Active",
      "Inactive": "Inactive",
      "Archived": "Archived",
      "InStock": "In stock",
      "OutOfStock": "Out of stock",
      "Discontinued": "Discontinued"
    },
    "blueprintStatus": {
      "Draft": "Draft",
      "PendingApproval": "Pending approval",
      "Active": "Active",
      "Inactive": "Inactive",
      "Archived": "Archived"
    },
    "variantStatus": {
      "InStock": "In stock",
      "OutOfStock": "Out of stock",
      "Discontinued": "Discontinued"
    },
    "empty": {
      "cell": "—",
      "list": "No prices match these filters."
    },
    "error": {
      "load": "Could not load prices. Please try again."
    },
    "pagination": {
      "rowsPerPage": "Rows per page",
      "range": "Showing {{from}}–{{to}} of {{total}}",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "aria": "Prices pagination"
    },
    "export": {
      "button": "Export",
      "success": "Exported {{count}} rows.",
      "error": "Export failed. Please try again."
    }
  }
}
